import { nullable, number, string, struct, union } from 'io-ts/Decoder';

import { Certainty } from './Certainty';

export const Parameter = struct({
	value: nullable(union(string, number)),
	certainty: Certainty,
});
